import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-not-logged-in',
  templateUrl: './admin-not-logged-in.component.html',
  styleUrls: ['./admin-not-logged-in.component.scss'],
})
export class AdminNotLoggedInComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
